import {
  CARD_WIDTH,
  EDGE_CORNER_RADIUS,
  MIN_STEP_CORNER_SPAN,
  SPINE_OFFSET,
} from "../graph/constants";

// eslint-disable-next-line import/no-unused-modules -- consumed by StepEdge (Task 10)
export interface StepEdgePath {
  /** Vertical spine + corner (legacy border-left). */
  spinePath: string;
  /** Final horizontal stub into the target card (legacy border-bottom). */
  stubPath: string | null;
  /** Single-segment fallback when cards are not column-aligned. */
  straightPath: string | null;
}

/** L-shaped connector hugging the card's left edge — replica of StyledLine
 *  (Sidebar/style.tsx): down the left side, rounded corner, stub into target. */
export const buildStepEdgePath = (
  sourceX: number,
  sourceY: number,
  targetX: number,
  targetY: number,
  cardWidth: number = CARD_WIDTH,
  cornerRadius: number = EDGE_CORNER_RADIUS,
  spineOffset: number = SPINE_OFFSET,
): StepEdgePath => {
  if (Math.abs(sourceX - targetX) > 1) {
    return {
      spinePath: "",
      stubPath: null,
      straightPath: `M ${sourceX},${sourceY} L ${targetX},${targetY}`,
    };
  }

  const cardLeft = sourceX - cardWidth / 2;
  const span = targetY - sourceY;

  // RF nodes sit CARD_VGAP apart — squashing an L into ~10px leaves stray
  // corner ticks between blocks. Draw a plain vertical spine in the gap.
  if (span < MIN_STEP_CORNER_SPAN) {
    return {
      spinePath: `M ${cardLeft},${sourceY} L ${cardLeft},${targetY}`,
      stubPath: null,
      straightPath: null,
    };
  }

  const r = Math.min(cornerRadius, span / 2);

  const spinePath = [
    `M ${cardLeft},${sourceY}`,
    `L ${cardLeft},${targetY - r}`,
    `Q ${cardLeft},${targetY} ${cardLeft + r},${targetY}`,
  ].join(" ");

  const stubEndX = cardLeft + r + spineOffset;
  const stubPath =
    r > 0 ? `M ${cardLeft + r},${targetY} L ${stubEndX},${targetY}` : null;

  return { spinePath, stubPath, straightPath: null };
};
